export const ICITY_ORGANISATION_UUID = 'icity';
